import { CDefine, CEnumTypes } from "./CEnumTypes";

export class CLobbyTable {
    public index:number;
    public idxTable:number;
    public Base:number;
    public Bonus:number;
    public Secs:number;
    public fgTinGun:number;
    public Round:number;
    public Cost:number;
    public fgPass:number;

    public fgTingHu:number;

    public serverIP:string;
    public serverPort:number;
    public password:string;

    public commissionZiMo:number;
    public commissionHu:number;

    public players:number;
    public ready:Array<number> = new Array<number>(4);
    public openid:Array<string> = new Array<string>(4);
    public socialName:Array<string> = new Array<string>(4);
    public szIP:Array<string> = new Array<string>(4);
    public pictureURL:Array<string> = new Array<string>(4);
    public fgAvatar:Array<number> = new Array<number>(4);

    constructor() {
        this.Reset();
        console.log("LobbyTable Reset !!!!");
    }

    public Reset():void {
        this.players = 0;
        this.fgTingHu = 0;
        for( var i = 0; i < CDefine.PLAYER_NUMS; i ++ ) {
            this.ready[i] = 0;
            this.openid[i] = null;
            this.socialName[i] = null;
            this.szIP[i] = null;
            this.pictureURL[i] = null;
            this.fgAvatar[i] = 0;
        }
    }
}